import { RightOutlined, SearchOutlined, PrinterOutlined, FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Input, PageHeader, Row, Select, Space, Spin, Table, DatePicker, Typography } from 'antd'
import moment from 'moment';
import JcpMonthlyPaidListView from '../../components/enrollment/jcp/JcpMonthlyPaidListView'
import ProgrammeService from '../../api/programme.service'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'
import PaymentPaidList from '../../components/payment/PaymentPaidList'

import { SUCCESS_STATUS } from '../../utility/Constants'
import memberService from "../../api/member.service";
import JcpMonthlyReminderListView from "../../components/enrollment/jcp/JcpMonthlyReminderListView";
import TapMembershipListView from "../../components/tapcomponent/TapMembershipListView";
import CustomTableSearch from "../../components/common/CustomTableSearch";
import gymService from "../../api/gym.service";
import GymMembershipListView from "../../components/gymcomponent/GymMembershipListView";
import commonUtility from "../../utility/Utils";
import { GYM_MEMBER_PDF_URL, GYM_MEMBER_XLS_URL } from "../../utility/URL";
const { Option } = Select;



const userInfo = commonUtility.getLoggedInUserInfo();

const currdate = new Date();
//const currMonth = currdate.toLocaleString('default', { month: 'short' });
const currMonth = currdate.getMonth() + 1;
const currYear = currdate.getFullYear();


// console.log("currMonth", currYear);

const defaultFormValues = {
    month_id: currMonth,
    year: currYear,
    member_id: "",
    programme_id: 0,
    paid_unpaid_status: "ALL"
};



const columns = [
    {
        title: 'Name',
        dataIndex: 'member_fname',
        key: 'member_fname',
    },
    {
        title: 'Mobile No',
        dataIndex: 'primary_mobile',
        key: 'primary_mobile',
    },
    {
        title: 'Father',
        dataIndex: 'father_name',
        key: 'father_name',
    },
];


const GymRegisteredMemberList = () => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [monthList, setMonthList] = useState([]);
    const [yearList, setYearList] = useState([]);
    const [memberList, setMemberList] = useState([]);
    const [programmeID, setProgrammeID] = useState(0);
    const [jcpMonthlyUnPaidList, setJcpMonthlyUnPaidList] = useState([]);

    // const [tapMembershipList, setTapMembershipList] = useState([]);
    // const [tapMembershipListMaster, setTapMembershipListMaster] = useState([]);


    const [tapMembershipList, setTapMembershipList] = useState([]);
    const [tapMembershipMasterData, setTapMembershipMasterData] = useState([]);
    const [tapMembershipDetailData, setTapMembershipDetailData] = useState([]);
    const [isDataUpdated, setIsDataUpdated] = useState(false);



    const [reminderLoaderEnable, setReminderLoaderEnable] = useState(false);


    const [filteredSearchList, setFilteredSearchList] = useState([]);





    /*
    const onJcpMonthlySearched = async (values) => {
        setJcpMonthlyUnPaidList([])
        setReminderLoaderEnable(true)
        const data = { formdata: values };
        console.log("InsideMethod", values);


        ProgrammeService.tapMemberList().then((res) => {
            //console.log("Response", res)
            //setJcpMonthlyUnPaidList(res.data.response_data)

        }).then(() => {
            setReminderLoaderEnable(false)
        });


    };
    */
    const columns2 = [
        {
            title: 'Start Date',
            dataIndex: 'test',
            key: 'test',
        },
        {
            title: 'End Date',
            dataIndex: 'test2',
            key: 'test2',
        },
        {
            title: 'Action',
            dataIndex: '',
            key: 'y',
            render: () => <a>Edit</a>,
        },

    ];

    /*
    useEffect(()=> {
        ProgrammeService.tapMemberList().then((res) => {
            const memberList = res.data.response_data;
            const dataList = [];
            memberList.forEach((obj,index) => {
                let dataX = {
                    key: obj.masterData.member_id,
                    member_fname: obj.masterData.member_fname,
                    primary_mobile: obj.masterData.primary_mobile,
                    father_name: obj.masterData.father_name,
                    
                }
                dataList.push(dataX)
            });
            setTapMembershipListMaster(dataList)
            setTapMembershipList(memberList)
        });  

    },[]);
    */




    useEffect(() => {
        gymService.gymListAll().then((res) => {
            const memberList = res.data.response_data;
            const dataList = [];

            setTapMembershipList(memberList)
            setFilteredSearchList(memberList)

        });

    }, []);







    /*
    const onSelectMember = (value) => {
        const data = { formdata: { member_id: value } };
    };

    useEffect(() => {
        ProgrammeService.yearList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setYearList(res.data.response_data);
            }

        });
    }, []);


    useEffect(() => {
        ProgrammeService.monthList().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMonthList(res.data.response_data);
            }

        });
    }, []);


    useEffect(() => {
        const data = {
            formdata: { short_code: "JCP" },
        };
        ProgrammeService.programmeByCode(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setProgrammeID(res.data.response_data[0].programme_id);
                form.setFieldsValue({
                    programme_id: res.data.response_data[0].programme_id,
                });
            }
        });
    }, []);


    useEffect(() => {
        memberService.allMember().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setMemberList(res.data.response_data);
            }
        });
    }, []);


    useEffect(() => {
        const defaultFormValuesInitial = {
            month_id: currMonth,
            year: currYear,
            member_id: "",
            programme_id: programmeID,
            paid_unpaid_status: "ALL"
        };

        onJcpMonthlySearched(defaultFormValuesInitial)
    }, [programmeID])
    */


    const onSearch = (e) => {
        setFilteredSearchList([]);
        const string = e.target.value;
        const x = tapMembershipList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
        setFilteredSearchList(x)
    }

    const handlePdfDownload = async () => {
        try {
            // const values = await form.validateFields();
            // const url_pdf = GYM_MEMBER_PDF_URL;
            // let url = buildPdfUrl(values, url_pdf);
            commonUtility.openInNewTab(GYM_MEMBER_PDF_URL);
        } catch (error) {
            console.error('Error generating PDF report:', error);
        }
    };
    const handleExcelDownload = async () => {
        try {
            // const values = await form.validateFields();
            // const url_xls = GYM_MEMBER_XLS_URL;
            // let url = buildPdfUrl(values, url_xls);
            commonUtility.openInNewTab(GYM_MEMBER_XLS_URL);
        } catch (error) {
            console.error('Error generating Excel report:', error);
        }
    };

    const buildPdfUrl = (values, url_first) => {
        let url = '';
        console.log(values);
        const formValues = {
            from_date: formatDate(values.fromDate ? moment(values.fromDate).format('DD/MM/YYYY') : '') || '',
            to_date: formatDate(values.toDate ? moment(values.toDate).format('DD/MM/YYYY') : '') || '',
        };

        if (formValues.from_date !== "" && formValues.to_date !== "") {
            url = `${url_first}/${userInfo.yearID}/${formValues.from_date}/${formValues.to_date}`;
        }
        return url;
    };

    const formatDate = (dateStr) => {
        return dateStr ? dateStr.replace(/\//g, '-') : '';
    };

    return (




        <div>


            <div className="inside-main-content">
                <AdminBreadCrumb />

                <div className="box-style">
                    <PageHeader
                        ghost={false}
                        onBack={() => window.history.back()}
                        title="Member Enrollment List - GYM"
                        subTitle=""
                    // extra={[
                    //     <Button key="gym_membership_pdf" className="custom-button-white" shape="round" size="medium"
                    //         onClick={() => commonUtility.openInNewTab(`${GYM_MEMBER_PDF_URL}/${userInfo.yearID}`)}>
                    //         <PrinterOutlined /> PDF
                    //     </Button>,

                    //     <Button key="gym_membership_xls" className="custom-button-white" shape="round" size="medium" onClick={() => commonUtility.openInNewTab(GYM_MEMBER_XLS_URL)}>
                    //         <FileExcelOutlined /> Excel
                    //     </Button>,
                    // ]}

                    ></PageHeader>

                    <Row className="" style={{ background: "transparent" }}>
                        <Col className="" xs={24} xl={24}>

                            {
                                /*
                            }
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={onJcpMonthlySearched}
                                autoComplete="off"
                                initialValues={defaultFormValues}
                                hidden={true}
                            >

                                <Row gutter={20}>

                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item name="month_id" label="Month" rules={[
                                            {
                                                required: true,
                                                message: "Select Month",
                                            },
                                        ]}>
                                            <Select className="text-left">

                                                {
                                                    monthList.length > 0 ?
                                                        monthList.map(month_list => (
                                                            <Option key={month_list.id} value={month_list.id}>{month_list.short_name}</Option>

                                                        ))
                                                        : ''
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item name="year" label="Year" rules={[
                                            {
                                                required: true,
                                                message: "Select Year",
                                            },
                                        ]} >
                                            <Select className="text-left"  >

                                                {
                                                    yearList.length > 0 ?
                                                        yearList.map(year_data => (
                                                            <Option key={year_data.year} value={year_data.year}>{year_data.year}</Option>

                                                        ))
                                                        : ''
                                                }
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item name="paid_unpaid_status" label="Status"  >
                                            <Select className="text-left" >
                                                <Option key="ALL" value="ALL">All</Option>
                                                <Option key="PAID" value="PAID">Paid</Option>
                                                <Option key="UNPAID" value="UNPAID">Unpaid</Option>

                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col xs={6} xl={6} style={{ margin: "0.5rem" }}>
                                        <Form.Item
                                            name="member_id"
                                            label="Search (Name | Mobile no | Father Name)"

                                        >
                                            <Select
                                                showSearch
                                                placeholder="Search to Select"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    //option.children.includes(input)
                                                    option.children.toLowerCase().includes(input.toLowerCase())
                                                }

                                                // filterOption={(inputValue, option) =>
                                                //     option.children.join('').toLowerCase().includes(inputValue.toLowerCase())
                                                //   }

                                                filterSort={(optionA, optionB) =>
                                                    optionA.children
                                                        .toLowerCase()
                                                        .localeCompare(optionB.children.toLowerCase())
                                                }
                                                onSelect={(value, event) =>
                                                    onSelectMember(value, event)
                                                }
                                                allowClear={true}
                                            >
                                                {memberList.length > 0
                                                    ? memberList.map((member_list) => (
                                                        <Option
                                                            key={member_list.member_id}
                                                            value={member_list.member_id}
                                                        >
                                                            {`${member_list.member_fname} ${member_list.member_lname
                                                                } | ${member_list.primary_mobile}  ${member_list.father_name != null
                                                                    ? member_list.father_name
                                                                    : ""
                                                                }`}
                                                        </Option>
                                                    ))
                                                    : ""}
                                            </Select>
                                            <Form.Item name="programme_id" hidden={true}>
                                                <Input type="text" />
                                            </Form.Item>
                                        </Form.Item>
                                    </Col>

                                   


                                    <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                        <Form.Item label=" ">


                                            {
                                                reminderLoaderEnable ? <Spin /> : <>
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"

                                                        className="custom-button-green"
                                                    >
                                                        Search <SearchOutlined />
                                                    </Button>
                                                </>
                                            }

                                        </Form.Item>
                                    </Col>



                                </Row>
                            </Form>

                            {
                                */
                            }



                        </Col>
                    </Row>
                    {/* <Row className="login-first-step-row" style={{ background: "#f4f4f4" }}>
                        <Col className="form-format-type1 enrollment-form jcp-enrollment" xs={24} xl={24}>
                            <Form
                                form={form}
                                layout="vertical"
                                autoComplete="off"
                                initialValues={defaultFormValues}
                            // onFinish={onFinish}
                            >
                                <Row gutter={20}>
                                    <Col xs={24} xl={24}>
                                        <Row gutter={20}> */}
                                            {/* <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                                <Form.Item
                                                    name="fromDate"
                                                    label="From Date"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Select From Date",
                                                        },
                                                    ]}
                                                >
                                                    <DatePicker style={{ width: "100%" }} placeholder="Select From Date" />
                                                </Form.Item>
                                            </Col> */}

                                            {/* <Col xs={4} xl={4} style={{ margin: "0.5rem" }}>
                                                <Form.Item
                                                    name="toDate"
                                                    label="To Date"
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message: "Select To Date",
                                                        },
                                                    ]}
                                                >
                                                    <DatePicker style={{ width: "100%" }} placeholder="Select To Date" />
                                                </Form.Item>
                                            </Col> */}

                                            {/* <Col xs={5} xl={5} style={{ margin: "0.5rem" }}>
                                                <Typography.Title level={5} style={{ margin: "1.5rem" }}>Active GYM Member List:</Typography.Title>
                                            </Col>

                                            <Col xs={2} xl={2} style={{ margin: "0.3rem" }}>
                                                <Form.Item label=" ">
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"
                                                        loading={loading}
                                                        className="custom-button-green"
                                                        onClick={handleExcelDownload}
                                                        icon={<FileExcelOutlined />}
                                                    >
                                                        Excel
                                                    </Button>
                                                </Form.Item>
                                            </Col>

                                            <Col xs={2} xl={2} style={{ margin: "0.3rem" }}>
                                                <Form.Item label=" ">
                                                    <Button
                                                        htmlType="submit"
                                                        shape="round"
                                                        loading={loading}
                                                        className="custom-button-green"
                                                        onClick={handlePdfDownload}
                                                        icon={<PrinterOutlined />}
                                                    >
                                                        PDF
                                                    </Button>
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row> */}

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Form.Item style={{ margin: 0 }}>
                                <Button
                                    htmlType="submit"
                                    shape="round"
                                    loading={loading}
                                    className="custom-button-green"
                                    onClick={handleExcelDownload}
                                    icon={<FileExcelOutlined />}
                                >
                                    Excel
                                </Button>
                            </Form.Item>

                            <Form.Item style={{ margin: 0 }}>
                                <Button
                                    htmlType="submit"
                                    shape="round"
                                    loading={loading}
                                    className="custom-button-green"
                                    onClick={handlePdfDownload}
                                    icon={<PrinterOutlined />}
                                >
                                    PDF
                                </Button>
                            </Form.Item>
                        </div>
                        <div style={{ flex: 1, maxWidth: '1000px' }}>
                            <CustomTableSearch onSearchTable={onSearch} />
                        </div>
                    </div>
                    <div className='tableView'>
                        <div className="form-content">
                            <GymMembershipListView tapMembershipList={filteredSearchList} />
                        </div>
                    </div>

                </div>
            </div>

        </div>







    )
}

export default GymRegisteredMemberList